import NSPO from "./nspo_123456.pdf";
import MC19S2019 from "./mc19s2019_forms.pdf";
import EOI from "./eoi-amnesty-of-fines-and-penalties.docx";
import NON_COMPLIANT from "./application-for-availment-of-amnesty-of-fines-and-penalties.docx";
import REVOKED_SUSPENDED from "./application-for-availment-of-amnesty-of-fines-and-penalties-revokedsuspended.docx";
import UNDERTAKING from "./undertaking_for_submission_of_fs_v2.docx";
import PETITION from "./Amnesty Petition to Lift - Sample Format.pdf";
import FILING from "./filing_012025.pdf";
import GUIDE from "./user_guide_022825.pdf";
import SECONDARY from "./secondary_guide_04042025.pdf";
import CHECKLIST from "./img/checklist.jpg";
import GIS_STOCK_2026 from "./2026Forms_2026-Version-GIS-Stock.xlsx";
import GIS_NON_STOCK_2026 from "./2026Forms_2026-Version-GIS-Non-Stock.xlsx";

export const img_checklist = CHECKLIST;
export const file_nspo = NSPO;
export const file_mc19s2019 = MC19S2019;
export const file_eoi = EOI;
export const file_non_compliant = NON_COMPLIANT;
export const file_revoked_suspended = REVOKED_SUSPENDED;
export const file_undertaking = UNDERTAKING;
export const file_petition = PETITION;
export const filing_guide  = FILING;
export const user_guide  = GUIDE;
export const secondary_guide = SECONDARY;
export const file_gis_stock_2026 = GIS_STOCK_2026;
export const file_gis_non_stock_2026 = GIS_NON_STOCK_2026;